import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

const scaleIn = keyframes`
    from {
        transform: scale(0.95);
        opacity: 0;
    }
    to {
        transform: scale(1);
        opacity: 1;
    }
`;

export const ZoomOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.95);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 20000;
    animation: ${fadeIn} 0.2s ease-out;
`;

export const ZoomContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    animation: ${scaleIn} 0.2s ease-out;

    /* Estilos para los divs internos de react-zoom-pan-pinch */
    .zoom-wrapper {
        width: 100% !important;
        height: 100% !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
    }

    .zoom-content {
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
    }
`;

export const ZoomControls = styled.div`
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 10px;
    z-index: 10;
    background: rgba(0, 0, 0, 0.6);
    padding: 8px 12px;
    border-radius: 30px;
    backdrop-filter: blur(10px);

    @media (max-width: 480px) {
        top: 15px;
        padding: 6px 10px;
        gap: 8px;
    }
`;

export const ZoomButton = styled.button`
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: white;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    cursor: pointer;
    font-size: 1.4rem;
    font-weight: 300;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;

    &:hover {
        background: rgba(107, 91, 255, 0.5);
        border-color: rgba(107, 91, 255, 0.8);
        transform: scale(1.1);
    }

    &:active {
        transform: scale(0.95);
    }

    @media (max-width: 480px) {
        width: 38px;
        height: 38px;
        font-size: 1.2rem;
    }
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 20px;
    right: 20px;
    background: rgba(255, 255, 255, 0.15);
    border: 2px solid rgba(255, 255, 255, 0.3);
    color: white;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    cursor: pointer;
    font-size: 1.5rem;
    font-weight: 300;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    z-index: 10;

    &:hover {
        background: rgba(255, 107, 139, 0.4);
        border-color: rgba(255, 107, 139, 0.6);
        transform: rotate(90deg) scale(1.1);
    }

    @media (max-width: 480px) {
        top: 15px;
        right: 15px;
        width: 44px;
        height: 44px;
        font-size: 1.3rem;
    }
`;

export const ZoomImage = styled.img`
    max-width: 90vw;
    max-height: 85vh;
    object-fit: contain;
    user-select: none;
    -webkit-user-drag: none;

    @media (max-width: 480px) {
        max-width: 95vw;
        max-height: 80vh;
    }
`;

export const ZoomInstructions = styled.div`
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.6);
    color: rgba(255, 255, 255, 0.7);
    padding: 10px 20px;
    border-radius: 20px;
    font-size: 0.85rem;
    backdrop-filter: blur(10px);
    white-space: nowrap;

    @media (max-width: 768px) {
        font-size: 0.75rem;
        padding: 8px 16px;
        white-space: normal;
        text-align: center;
        max-width: 90%;
    }

    @media (max-width: 480px) {
        bottom: 15px;
    }
`;
